<div class="card shadow-sm border-0 mb-4">
  
  <div class="position-relative">
    <img [src]="community?.banner_url" class="w-100 img-fluid banner-img" />
    <div class="position-absolute" style="bottom: -50px; left: 20px;">
      <img
        [src]="community?.logo_url"
        class="rounded-circle border border-white shadow logo-img"
      />
    </div>
  </div>

 
  <div class="card-body pt-5 mt-3">
    <h2 class="fw-bold text-dark card-title">
      {{ community?.community_name }}
    </h2>
    <p class="text-muted">{{ community?.about_us_content }}</p>

  
    <div
      *ngIf="communityStats?.latest_users?.length > 0"
      class="latest-users-section mt-4 d-flex align-items-center flex-wrap gap-3"
    >
     
      <div class="d-flex align-items-center gap-3 flex-wrap">
        <ng-container *ngFor="let user of communityStats.latest_users">
          <div class="text-center">
            <img
              [src]="user.avatar || profilePhoto"
              alt="{{ user.name }}"
              class="rounded-circle latest-user-img border"
            />
            <div class="small fw-semibold mt-1 text-dark text-center">
              {{ user.name }}
            </div>
          </div>
        </ng-container>
      </div>

    
      <div class="text-muted small ms-2 text-details">
        <ng-container *ngIf="communityStats.total_users > 3">
          <span class="fw-semibold">&amp;</span>
          {{ communityStats.total_users - 3 }}
          more {{ (communityStats.total_users - 3) === 1 ? 'member' : 'members' }} and growing!
          <a
            class="ms-2 text-primary fw-semibold clickButton"
            (click)="goToUserList()"
          >
            See Details
          </a>
        </ng-container>

        <ng-container *ngIf="communityStats.total_users <= 3">
          {{ communityStats.total_users }}
          {{ communityStats.total_users === 1 ? 'member' : 'members' }} and growing!
          <a
          class="ms-2 text-primary fw-semibold clickButton"
          (click)="goToUserList()"
        >
          See Details
        </a>
        </ng-container>
      </div>
    </div>
  </div>
</div>
